"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
const GraphandModelList_1 = __importDefault(require("../lib/GraphandModelList"));
const GraphandModelListPromise_1 = __importDefault(require("../lib/GraphandModelListPromise"));
const GraphandModelPromise_1 = __importDefault(require("../lib/GraphandModelPromise"));
const _decode = (value) => {
    if (value instanceof GraphandModelList_1.default ||
        value instanceof GraphandModelListPromise_1.default ||
        value instanceof GraphandModel_1.default ||
        value instanceof GraphandModelPromise_1.default) {
        return value.encodeQuery();
    }
    else if (value && typeof value === "object" && Object.keys(value).length) {
        if (Array.isArray(value)) {
            return value.map(_decode);
        }
        else {
            return parsePayload(value);
        }
    }
    return value;
};
const parsePayload = (payload) => {
    var _a;
    if (!payload) {
        return {};
    }
    if (((_a = payload.constructor) === null || _a === void 0 ? void 0 : _a.name) === "FormData") {
        return payload;
    }
    let res;
    if (Array.isArray(payload)) {
        res = payload.map((row) => _decode(row));
    }
    else {
        res = Object.keys(payload).reduce((final, key) => Object.assign(final, { [key]: _decode(payload[key]) }), {});
    }
    return res;
};
exports.default = parsePayload;
